import { BrokerCommunication } from "@dune/types";
import type { PaginatedResponse } from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { communicationsQueryKeys } from "../query-keys/communications.query-keys";

export interface GetAllCommunicationsParams {
	page?: number;
	limit?: number;
	sortBy?: string;
	sortOrder?: "asc" | "desc";
}

export const getAllCommunications = async (
	params?: GetAllCommunicationsParams,
): Promise<PaginatedResponse<BrokerCommunication>> => {
	const { data } = await privateAxios.get<
		PaginatedResponse<BrokerCommunication>
	>("/communications", { params });
	return data;
};

export const useGetAllCommunications = (
	params?: GetAllCommunicationsParams,
) => {
	return useQuery({
		queryKey: communicationsQueryKeys.allWithParams(params),
		queryFn: () => getAllCommunications(params),
		staleTime: 30 * 1000,
	});
};

export const getAllUnprocessedCommunications = async (
	params?: GetAllCommunicationsParams,
): Promise<PaginatedResponse<BrokerCommunication>> => {
	const { data } = await privateAxios.get<
		PaginatedResponse<BrokerCommunication>
	>("/communications/unprocessed", { params });
	return data;
};

export const useGetAllUnprocessedCommunications = (
	params?: GetAllCommunicationsParams,
) => {
	return useQuery({
		queryKey: communicationsQueryKeys.unprocessed(params),
		queryFn: () => getAllUnprocessedCommunications(params),
		staleTime: 30 * 1000,
	});
};
